import React, { useState } from "react";
import IconButton from "@mui/material/IconButton";
import MessageIcon from "@mui/icons-material/Message";
import Badge from "@mui/material/Badge";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useNavigate, NavLink } from "react-router-dom";
import FormatTimeAgo from "../../components/FormatTimeAgo";
import { Typography } from "@mui/material";

import { useUnreadMessages } from "../../context/UnreadMessagesContext";
import { useTranslation } from "react-i18next";

const UnReadNotification = () => {
  const { t } = useTranslation(["Header"]);
  const { unreadMessages } = useUnreadMessages();
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickNewMessage = async (msg) => {
    const chatId = msg?.chatId;

    navigate(`/minar-sidur/chats`, {
      state: {
        chatId: chatId,
      },
    });
    setAnchorEl(null);
  };

  const unreadCount = unreadMessages?.length || 0;

  return (
    <>
      <IconButton
        onClick={handleClick}
        color="primary"
        sx={{
          backgroundColor: "#333",
          padding: "11px",
        }}
      >
        <Badge badgeContent={unreadCount} color="error">
          <MessageIcon />
        </Badge>
      </IconButton>
      <Menu
        id="notification-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        sx={{
          "& .MuiPaper-root": {
            width: "500px",
            maxHeight: "80vh", // Set the maximum height relative to the viewport height
            overflowY: "auto", // Enable scrolling
            "&::-webkit-scrollbar": {
              width: "6px", // Adjust scrollbar width
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "rgba(0, 0, 0, 0.4)", // Scrollbar color
              borderRadius: "2px", // Scrollbar border radius
            },
          },
        }}
      >
        <Typography
          sx={{
            padding: "10px 16px",
            borderBottom: "1px solid #e0e0e0", // Line under header
            wordWrap: "break-word", // Ensure long text wraps to the next line
          }}
        >
          {t("newMessage")}
        </Typography>
        {unreadMessages?.length > 0 ? (
          unreadMessages.map((messageData) => {
            let message = messageData.message;
            const isRead = message.isRead;
            return (
              <MenuItem
                key={message._id}
                onClick={() => handleClickNewMessage(messageData)}
                sx={{
                  backgroundColor: isRead ? "white" : "#D3FAD9",
                  color: "black",
                  "&:hover": {
                    backgroundColor: isRead ? "#78CA72" : "#78CA72",
                  },
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  whiteSpace: "normal", // Allows text to wrap
                  overflowWrap: "break-word", // Breaks words to prevent overflow
                }}
              >
                <strong>{message?.sender?.name}</strong>
                <span>
                  {message?.text
                    ? message?.text
                    : t("notification.chatFileMessage")
                        ?.replace("%senderName%", `${message?.sender?.name}`)
                        ?.replace("%fileName%", `${message?.file?.fileName}`)}
                </span>
                <span
                  style={{
                    fontSize: "0.8em",
                    color: "grey",
                    paddingTop: "5px",
                  }}
                >
                  <FormatTimeAgo date={message.timestamp} />
                </span>
              </MenuItem>
            );
          })
        ) : (
          <MenuItem
            onClick={() => {
              navigate("/minar-sidur/chats");
              handleClose();
            }}
            sx={{
              color: "black",
              textDecoration: "none",
              padding: "10px 16px",
              borderBottom: "1px solid #e0e0e0",
              display: "block",
              backgroundColor: "transparent",
              '&:hover': {
                backgroundColor: '#f5f5f5',
              },
            }}
          >
            {t("gotoChats")}
            <Typography
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                whiteSpace: "normal",
                overflowWrap: "break-word",
                backgroundColor: "transparent",
                "&:hover": {
                  backgroundColor: "transparent",
                },
              }}
            >
              {t("noNewMessage")}
            </Typography>
          </MenuItem>
        )}
      </Menu>
    </>
  );
};

export default UnReadNotification;
